import { DecimalPipe, NgIf } from "@angular/common";
import { Component, Input } from "@angular/core";
import { AbstractControl, FormArray, FormControl } from "@angular/forms";
import {
  ExpenseDayMax,
  ExpenseYearMax,
  IncreasedExpenseYearMax,
} from "projects/assist/src/app/expenses/models/expense";

@Component({
  selector: "app-validator",
  templateUrl: "./validator.component.html",
  styleUrls: ["./validator.component.scss"],
  standalone: true,
  imports: [NgIf, DecimalPipe],
})
export class ValidatorComponent {
  @Input() control!: FormControl | FormArray | AbstractControl;
  @Input() label: string | null = null;
  @Input() type: string | null = "";
  @Input() text: string | null = "";

  protected currentYear = new Date();
  protected ExpenseDayMax = ExpenseDayMax;
  protected IncreasedYearMax = IncreasedExpenseYearMax;
  protected YearMax = ExpenseYearMax;

  protected readonly defaultLabel = "Dit veld";

  constructor() {}

  get effectiveLabel() {
    return this.label ? `'${this.label}'` : null;
  }
}
